/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trite_Grand_Lobster_SoarInputs */

const fr_trite_grand_lobster_soar = /** @type {(inputs: Trite_Grand_Lobster_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`détail`)
};

/**

* @param {Trite_Grand_Lobster_SoarInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const trite_grand_lobster_soar = /** @type {((inputs?: Trite_Grand_Lobster_SoarInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trite_Grand_Lobster_SoarInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_trite_grand_lobster_soar(inputs)
});